import {roleSystemRoute} from './route_utilities'

import Educationpacks from '../../views/educationpacks/Educationpacks.vue'
import Educationpack from '../../views/educationpacks/Educationpack.vue'
import EducationpackGeneral from '../../views/educationpacks/EducationpackGeneral.vue'
import EducationpackVideos from '../../views/educationpacks/EducationpackVideos.vue'
import CreateEducationpackVideo from '../../views/educationpacks/CreateEducationpackVideo.vue'
import EducationpackVideo from '../../views/educationpacks/EducationpackVideo.vue'

export const educationpacks =  {
      path: 'educationpacks',
      name: 'Educationpacks',
      component: Educationpacks,
      meta: {
          title: "egitim_paketleri",
          domain:"educationpacks",
          accessroles:["admin","brand","auditor","planner"],
        },
      }
export const educationpack =  {
      path: 'educationpack/:id',
      name: 'Educationpack',
      component: Educationpack,
      redirect: { name: 'EducationpackGeneral' },
      meta: {
          title: "Eğitim Paketi",
          domain:"educationpacks",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'EducationpackGeneral',
          component: EducationpackGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"educationpacks"
            },
          },
          {
          path: 'videos',  
          name: 'EducationpackVideos',
          component: EducationpackVideos,
          meta: {
              title: "videolar",
              preloader:true,
              domain:"educationpacks"
            },
          },
          {
          path: 'video/:video_id',  
          name: 'EducationpackVideo',
          component: EducationpackVideo,
          meta: {
              title: "video",
              preloader:true,
              domain:"educationpacks"
            },
          },
          {
          path: 'video',  
          name: 'CreateEducationpackVideo',
          component: CreateEducationpackVideo,
          meta: {
              title: "yeni_video",
              preloader:true,
              domain:"educationpacks"
            },
          },
           
        ]
      }